import styles from "./style.module.scss";
import Logo from "../../images/logo2.png";
import { Link, useNavigate } from "react-router-dom";
import { IconMail, IconBrandLinkedin } from "@tabler/icons-react";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.footer}>
      <div
        className={`${styles.container} container form-group col-md-12 uk-animation-slide-left-medium`}
        data-uk-scrollspy="cls: uk-animation-slide-left-medium; repeat: false; delay: 400;"
      >
        <div className={styles.content}>
          <div className={styles.infos}>
            <div className="logo-footer">
              <img onClick={() => navigate("/")} src={Logo} alt="" />
              <p className="paragraph white ">
                “Seriedade, profissionalismo e transparência, buscando sempre o
                melhor atendimento e satisfação de nossos clientes.”
              </p>
            </div>
            <div className={styles.redesSociais}>
              <div className={styles.redesSociais}>
                <a
                  href="https://www.linkedin.com/in/katiane-thom%C3%A1s-05812859/?originalSubdomain=pt"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <IconBrandLinkedin stroke={2} color="#ffffffff" />
                </a>
                <a
                  href="mailto:contato@thomastalent.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <IconMail stroke={2} color="#ffffffff" />
                </a>
              </div>
            </div>
          </div>

          <div className={styles.navbar}>
            <div className={styles.itemOne}>
              <span className="white font-footer">Produtos</span>
              <ul className="menu-footer">
                <li>
                  <Link className="sub-footer" to="/">
                    Home
                  </Link>
                </li>
                <li >
                  <Link className="sub-footer" to="/recursos-humanos">
                    Recursos Humanos
                  </Link>
                </li>

                <li>
                  <Link className="sub-footer" to="/desenvolvimento-de-carreira">
                    Desenvolvimento de Carreira
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="w-100" />
        <div className="w-100 d-flex justify-content-center">
          <em className="copyright white">
            {" "}
            Copyright &copy; 2025 por Thomas Talent RH. Todos os direitos
            reservados.
          </em>
        </div>
      </div>
    </section>
  );
};

export default Footer;
